import React, { useState } from 'react';
import Ruleta from '../Ruleta/Ruleta';
import { supabase } from '../../supabaseClient';
import './ModalSorteo.css';

const ModalSorteo = ({ alFinalizar, userId, jornadaActiva, checkpoint }) => {
  const sortearTodo = () => {
    const pres = opcionesBase.presupuestos[Math.floor(Math.random() * opcionesBase.presupuestos.length)];
    const form = opcionesBase.formaciones[Math.floor(Math.random() * opcionesBase.formaciones.length)];
    const cantOpts = opcionesBase.cantidades;
    const cant = parseInt(cantOpts[Math.floor(Math.random() * cantOpts.length)]);
    const pool = [...opcionesBase.listaRestricciones].sort(() => Math.random() - 0.5);
    const restricciones = pool.slice(0, cant).map(t => ({ id: Date.now() + Math.random(), texto: t, cumplida: false }));
    const resultado = { presupuesto: pres, formacion: form, cantidad: cant, restricciones };
    guardarCheckpoint(99, resultado);
    return resultado;
  };

  const onSorteoTotalConfirmado = (resultado) => {
    alFinalizar(resultado);
  };

  const pasoInicial = checkpoint?.sorteo_paso || 0;
  const tempInicial = checkpoint?.sorteo_temp || { presupuesto: '', formacion: '', cantidad: 0, restricciones: [] };

  const pasoRealInicial = (() => {
    if (pasoInicial === 99) return 99;
    if (pasoInicial === 0 && tempInicial.presupuesto) return 1;
    if (pasoInicial === 1 && tempInicial.formacion) return 2;
    if (pasoInicial === 2 && tempInicial.cantidad > 0) return 3;
    return pasoInicial;
  })();
  const [paso, setPaso] = useState(pasoRealInicial);
  const [bloqueado, setBloqueado] = useState(false);
  const [girosRestriccionEfectuados, setGirosRestriccionEfectuados] = useState(
    tempInicial.restricciones?.length || 0
  );
  const [tempData, setTempData] = useState(tempInicial);

  const opcionesBase = {
    presupuestos: ["$70M", "$77M", "$72M", "$70M", "$68M", "$72M", "$70M", "$65M", "$68M", "$68M", "$67M"],
    formaciones: ['4-3-3', '4-4-2', '3-5-2', '5-3-2', '3-4-3', '4-5-1', '5-2-3', '4-2-4', '3-3-4'],
    cantidades: ["2", "2", "2", "2", "2", "1", "2", "2", "2"],
    listaRestricciones: [
      //"Al menos 3 zurdos",
      //"Mínimo 1 Sub-23",
      //"Mínimo 2 jugadores con +33 años",
      "Máximo 2 jugadores con +33 años",
      //"Máximo 4 jugadores de más de $6.5M",
      "Máximo 2 jugadores de la última final del mundial",
      //"Mínimo 2 ex Serie A",
      //"Mínimo 2 ex Premier League",
      //"Mínimo 2 ex La Liga",
      //"Mínimo 2 ex Ligue 1",
      //"Mínimo 2 ex Bundesliga",
      //"Mínimo 1 ex Eredivisie",
      "Mínimo 2 Serie A actual",
      "Mínimo 2 La Liga actual",
      "Mínimo 2 Ligue 1 actual",
      "Mínimo 2 Bundesliga actual",
      "Mínimo 1 Eredivisie actual",
      "Mínimo 3 jugadores Premier actual",
      "Mínimo 2 defensores sudamericanos",
      "Mínimo 2 defensores europeos",
      //"Mínimo 1 defensor asiático",
      "Mínimo 1 defensor africano",
      //"Mínimo 1 defensor de Oceanía",
      "Máximo 1 defensor europeo",
      "Máximo 1 defensor sudamericano",
      //"Mínimo 1 delantero asiático",
      //"Mínimo 2 delanteros africanos",
      "Máximo 6 jugadores de selecciones campeonas del mundo",
      "Máximo 4 europeos",
      "Mínimo 2 de América",
      "Mínimo 3 de la misma selección",
      //"Mínimo 1 arquero zurdo",
      //"Máximo 3 dorsales 10",
      //"Máximo 3 dorsales 9",
      //"Máximo 3 dorsales 7",
      //"Máximo 3 dorsales 11",
      //"Mínimo 1 jugador de las 3 peores selecciones del ranking FIFA",
      //"Ningún jugador de las 3 mejores selecciones del ranking FIFA",
      "Mínimo 3 jugadores con altura +1.82",
      "Mínimo 3 jugadores con altura +1.80",
    ]
  };

  const guardarCheckpoint = async (nuevoPaso, nuevoTemp) => {
    if (!userId || !jornadaActiva) return;
    await supabase.from('drafts').upsert({
      user_id: userId,
      jornada: jornadaActiva,
      sorteo_paso: nuevoPaso,
      sorteo_temp: nuevoTemp,
    }, { onConflict: 'user_id,jornada' });
  };

  const manejarGiro = (elegido) => {
    setBloqueado(true);

    if (paso === 0) {
      const nuevoTemp = { ...tempData, presupuesto: elegido };
      setTempData(nuevoTemp);
      guardarCheckpoint(1, nuevoTemp);
      setTimeout(() => { setPaso(1); setBloqueado(false); }, 1500);
    } 
    else if (paso === 1) {
      const nuevoTemp = { ...tempData, formacion: elegido };
      setTempData(nuevoTemp);
      guardarCheckpoint(2, nuevoTemp);
      setTimeout(() => { setPaso(2); setBloqueado(false); }, 1500);
    } 
    else if (paso === 2) {
      const cant = parseInt(elegido);
      const nuevoTemp = { ...tempData, cantidad: cant };
      setTempData(nuevoTemp);
      guardarCheckpoint(3, nuevoTemp);
      setTimeout(() => { setPaso(3); setBloqueado(false); }, 1500);
    } 
    else if (paso === 3) {
      const nuevaLista = [...tempData.restricciones, { id: Date.now(), texto: elegido, cumplida: false }];
      const nuevoTemp = { ...tempData, restricciones: nuevaLista };
      setTempData(nuevoTemp);
      
      const conteoActualizado = girosRestriccionEfectuados + 1;
      
      if (conteoActualizado >= tempData.cantidad) {
        guardarCheckpoint(99, nuevoTemp);
        setTimeout(() => alFinalizar(nuevoTemp), 1500);
      } else {
        setGirosRestriccionEfectuados(conteoActualizado);
        guardarCheckpoint(3, nuevoTemp);
        setTimeout(() => setBloqueado(false), 1500);
      }
    }
  };

  const [resultadoMobile, setResultadoMobile] = useState(
    pasoRealInicial === 99 && tempInicial.presupuesto ? tempInicial : null
  );

  const esMobile = typeof window !== 'undefined' && 
    (window.innerWidth <= 768 || window.innerHeight <= 720);

  return (
    <div className="modal-sorteo-overlay" style={{ alignItems: 'center' }}>
      <div className="modal-sorteo-card" style={{ 
        maxHeight: '92vh', 
        overflowY: 'auto', 
        overflowX: 'hidden',
        scrollbarWidth: 'thin',
        scrollbarColor: '#00f2ff44 transparent'
      }}>
        <h2 className="sorteo-titulo">DRAFT DE TORNEO</h2>

        {/* ── MOBILE: solo botón sortear todo ── */}
        {esMobile && !resultadoMobile && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', padding: '10px 0' }}>
            <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: 0 }}>
              Girá todas las ruletas de una vez
            </p>
            <button
              onClick={() => {
                const res = sortearTodo();
                setResultadoMobile(res);
              }}
              style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '50px', padding: '16px 36px', fontWeight: '900', fontSize: '1.1rem', cursor: 'pointer', letterSpacing: '1px', boxShadow: '0 0 24px #00f2ff66' }}
            >
              🎰 Sortear todo
            </button>
          </div>
        )}

        {/* ── MOBILE: resumen del resultado ── */}
        {esMobile && resultadoMobile && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '10px 0' }}>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <span style={{ background: '#0a1628', border: '1px solid #00f2ff44', borderRadius: '20px', padding: '6px 14px', color: '#00f2ff', fontSize: '0.88rem', fontWeight: 'bold' }}>
                 {resultadoMobile.presupuesto}
              </span>
              <span style={{ background: '#0a1628', border: '1px solid #00f2ff44', borderRadius: '20px', padding: '6px 14px', color: '#00f2ff', fontSize: '0.88rem', fontWeight: 'bold' }}>
                 {resultadoMobile.formacion}
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <p style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', margin: 0, textAlign: 'center' }}>
                {resultadoMobile.cantidad} Restricciones
              </p>
              {resultadoMobile.restricciones.map((r, i) => (
                <div key={i} style={{ background: '#0a1628', border: '1px solid #22c55e44', borderRadius: '10px', padding: '10px 14px', color: '#22c55e', fontSize: '0.85rem', fontWeight: 'bold', textAlign: 'left' }}>
                   {r.texto}
                </div>
              ))}
            </div>
            <button
              onClick={() => onSorteoTotalConfirmado(resultadoMobile)}
              style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '50px', padding: '14px 32px', fontWeight: '900', fontSize: '1rem', cursor: 'pointer', marginTop: '4px' }}
            >
              ✓ Confirmar y armar equipo
            </button>
          </div>
        )}

        {/* ── DESKTOP: flujo normal con ruletas ── */}
        {!esMobile && pasoRealInicial === 99 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '10px 0' }}>
            <h2 style={{ color: '#00f2ff', margin: '0 0 8px', letterSpacing: '2px', textAlign: 'center' }}>TU DRAFT</h2>
            <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#64748b' }}>Presupuesto</span>
              <span style={{ color: '#f5a623', fontWeight: 'bold' }}>{tempInicial.presupuesto}</span>
            </div>
            <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#64748b' }}>Formación</span>
              <span style={{ color: '#00f2ff', fontWeight: 'bold' }}>{tempInicial.formacion}</span>
            </div>
            <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#64748b' }}>Restricciones</span>
              <span style={{ color: '#f000a8', fontWeight: 'bold' }}>{tempInicial.cantidad}</span>
            </div>
            {(tempInicial.restricciones || []).map((r, i) => (
              <div key={i} style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px' }}>
                <span style={{ color: '#e2e8f0' }}>{r.texto || r}</span>
              </div>
            ))}
            <button
              onClick={() => alFinalizar(tempInicial)}
              style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '50px', padding: '12px 32px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '8px' }}>
              Listo, a armar el equipo
            </button>
          </div>
        )}
        {!esMobile && pasoRealInicial !== 99 && (
          <>
            <p className="indicador-pasos-moderno">
              {paso < 3 ? `PASO ${paso + 1} DE 4` : `RESTRICCIÓN ${girosRestriccionEfectuados + 1} DE ${tempData.cantidad}`}
            </p>

            {(tempData.presupuesto || tempData.formacion || tempData.cantidad > 0 || tempData.restricciones?.length > 0) && (
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '12px' }}>
                {tempData.presupuesto && (
                  <span style={{ background: '#0a1628', border: '1px solid #22c55e44', borderRadius: '20px', padding: '4px 12px', color: '#22c55e', fontSize: '0.78rem', fontWeight: 'bold' }}>
                    {tempData.presupuesto}
                  </span>
                )}
                {tempData.formacion && (
                  <span style={{ background: '#0a1628', border: '1px solid #22c55e44', borderRadius: '20px', padding: '4px 12px', color: '#22c55e', fontSize: '0.78rem', fontWeight: 'bold' }}>
                    {tempData.formacion}
                  </span>
                )}
                {tempData.cantidad > 0 && (
                  <span style={{ background: '#0a1628', border: '1px solid #22c55e44', borderRadius: '20px', padding: '4px 12px', color: '#22c55e', fontSize: '0.78rem', fontWeight: 'bold' }}>
                    {tempData.cantidad} restricc.
                  </span>
                )}
                {tempData.restricciones?.map((r, i) => (
                  <span key={i} style={{ background: '#0a1628', border: '1px solid #22c55e44', borderRadius: '20px', padding: '4px 12px', color: '#22c55e', fontSize: '0.72rem', fontWeight: 'bold' }}>
                    {r.texto}
                  </span>
                ))}
              </div>
            )}

            <Ruleta 
              alSaltearTodo={sortearTodo}
              onSorteoTotalConfirmado={onSorteoTotalConfirmado}
              yaGiro={pasoRealInicial > 0 || !!tempData.presupuesto}
              opciones={
                paso === 0 ? opcionesBase.presupuestos 
                : paso === 1 ? opcionesBase.formaciones 
                : paso === 2 ? opcionesBase.cantidades 
                : (() => {
                    const GRUPOS_EXCLUYENTES = [
                      ['africano', 'africanos'],
                      ['europeo', 'europeos'],
                      ['sudamericano', 'sudamericanos'],
                      ['asiático', 'asiáticos'],
                      ['zurdo', 'zurdos'],
                      ['campeón', 'finalistas'],
                      ['ex premier', 'premier actual'],
                      ['ex serie'],
                      ['ex la liga'],
                      ['ex ligue'],
                      ['ex bundesliga'],
                      ['sub-23'],
                      ['+35', '+36'],
                      ['1.82', '1.80', 'altura'],
                    ];

                    const esPosicionContinente = (r) =>
                      ['defensor', 'delantero', 'volante', 'arquero'].some(p => r.includes(p)) &&
                      ['africano', 'europeo', 'sudamericano', 'asiático'].some(c => r.includes(c));

                    const yaElegidos = tempData.restricciones.map(r => r.texto.toLowerCase());
                    const yaPosContinente = yaElegidos.filter(esPosicionContinente).length;

                    return opcionesBase.listaRestricciones.filter(r => {
                      if (yaElegidos.includes(r.toLowerCase())) return false;
                      const rLow = r.toLowerCase();
                      if (esPosicionContinente(rLow)) {
                        if (yaPosContinente >= 2) return false;
                        if (yaElegidos.some(ya => esPosicionContinente(ya) &&
                          ['defensor','delantero','volante','arquero'].find(p => rLow.includes(p) && ya.includes(p)) &&
                          ['africano','europeo','sudamericano','asiático'].find(c => rLow.includes(c) && ya.includes(c))
                        )) return false;
                        return true;
                      }
                      for (const grupo of GRUPOS_EXCLUYENTES) {
                        const rEnGrupo = grupo.some(g => rLow.includes(g));
                        if (!rEnGrupo) continue;
                        const yaHayDelGrupo = yaElegidos.some(ya =>
                          !esPosicionContinente(ya) && grupo.some(g => ya.includes(g))
                        );
                        if (yaHayDelGrupo) return false;
                      }
                      return true;
                    });
                  })()
              }
              alTerminar={manejarGiro} 
              bloqueado={bloqueado}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ModalSorteo;